import { useTranslation } from 'react-i18next';
import Typography from '@lib/components/Typography/Typography';
import pdfPlaceholder from '@lib/assets/images/pdf-preview-placeholder.svg';
import { AiEntityRefBlock } from './utils/parseContentBlocks';
import styles from './AiAssistant.module.scss';

type Props = {
  block: AiEntityRefBlock;
};

// Renders a referenced document (entity_ref content block). The BE currently
// provides only { entityType: 'DocumentationVersion', id, label } — there is
// no version->documentation lookup API yet, so the per-source actions from
// the design (View document / Version notes / Details / Add to favorites)
// stay unwired until the BE exposes resolvable references.
function SourceCard({ block }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.sourceCard}>
      <div className={styles.sourceCardIcon}>
        <img src={pdfPlaceholder} alt="" />
      </div>
      <div className={styles.sourceCardBody}>
        <Typography variant="body" strong className={styles.sourceCardName}>
          {block.label || t('document')}
        </Typography>
        <div className={styles.sourceCardMeta}>
          <Typography variant="caption">PDF</Typography>
        </div>
      </div>
    </div>
  );
}

export default SourceCard;
